"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(fn, ms) {
  if (!ms) {
    return fn;
  }

  var last = 0;
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var now = Date.now();

    if (now - last > ms) {
      fn.apply(void 0, args);
      last = now;
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(void 0, args);
        last = Date.now();
      }, Math.max(0, ms - now + last));
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9kZWJvdW5jZS5qcyJdLCJuYW1lcyI6WyJmbiIsIm1zIiwibGFzdCIsInRpbWVvdXQiLCJhcmdzIiwibm93IiwiRGF0ZSIsImNsZWFyVGltZW91dCIsInNldFRpbWVvdXQiLCJNYXRoIiwibWF4Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsa0JBQVVBLEVBQVYsRUFBY0MsRUFBZCxFQUFrQjtBQUMvQixNQUFJLENBQUNBLEVBQUwsRUFBUztBQUNQLFdBQU9ELEVBQVA7QUFDRDs7QUFFRCxNQUFJRSxJQUFJLEdBQUcsQ0FBWDtBQUNBLE1BQUlDLE9BQU8sR0FBRyxJQUFkO0FBRUEsU0FBTyxZQUFhO0FBQUEsc0NBQVRDLElBQVM7QUFBVEEsTUFBQUEsSUFBUztBQUFBOztBQUNsQixRQUFNQyxHQUFHLEdBQUdDLElBQUksQ0FBQ0QsR0FBTCxFQUFaOztBQUVBLFFBQUlBLEdBQUcsR0FBR0gsSUFBTixHQUFhRCxFQUFqQixFQUFxQjtBQUNuQkQsTUFBQUEsRUFBRSxNQUFGLFNBQU1JLElBQU47QUFDQUYsTUFBQUEsSUFBSSxHQUFHRyxHQUFQO0FBQ0QsS0FIRCxNQUdPO0FBQ0xFLE1BQUFBLFlBQVksQ0FBQ0osT0FBRCxDQUFaO0FBRUFBLE1BQUFBLE9BQU8sR0FBR0ssVUFBVSxDQUFDLFlBQU07QUFDekJSLFFBQUFBLEVBQUUsTUFBRixTQUFNSSxJQUFOO0FBQ0FGLFFBQUFBLElBQUksR0FBR0ksSUFBSSxDQUFDRCxHQUFMLEVBQVA7QUFDRCxPQUhtQixFQUdqQkksSUFBSSxDQUFDQyxHQUFMLENBQVMsQ0FBVCxFQUFZVCxFQUFFLEdBQUdJLEdBQUwsR0FBV0gsSUFBdkIsQ0FIaUIsQ0FBcEI7QUFJRDtBQUNGLEdBZEQ7QUFlRCIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIChmbiwgbXMpIHtcbiAgaWYgKCFtcykge1xuICAgIHJldHVybiBmbjtcbiAgfVxuXG4gIGxldCBsYXN0ID0gMDtcbiAgbGV0IHRpbWVvdXQgPSBudWxsO1xuXG4gIHJldHVybiAoLi4uYXJncykgPT4ge1xuICAgIGNvbnN0IG5vdyA9IERhdGUubm93KCk7XG5cbiAgICBpZiAobm93IC0gbGFzdCA+IG1zKSB7XG4gICAgICBmbiguLi5hcmdzKTtcbiAgICAgIGxhc3QgPSBub3c7XG4gICAgfSBlbHNlIHtcbiAgICAgIGNsZWFyVGltZW91dCh0aW1lb3V0KTtcblxuICAgICAgdGltZW91dCA9IHNldFRpbWVvdXQoKCkgPT4ge1xuICAgICAgICBmbiguLi5hcmdzKTtcbiAgICAgICAgbGFzdCA9IERhdGUubm93KCk7XG4gICAgICB9LCBNYXRoLm1heCgwLCBtcyAtIG5vdyArIGxhc3QpKTtcbiAgICB9XG4gIH07XG59XG4iXX0=